import React from 'react';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { sanitizeGenericHtml } from 'utils/sanitize';
import { __t, applyTranslations } from 'utils/language';

import './email-unsubscribe.scss';

applyTranslations(require('./email-unsubscribe.i18n.json'));

class EmailUnsubscribeSuccess extends React.Component {
  render() {
    const additionalMessage = __t('email_unsubscribe.success_message_additional');
    return (
      <div>
        <div className="access-actions">
          <div className="email-unsubscribe__title">
            <SVGDynamicIcon
              name="checkmark-custom-fg"
              width={18}
              height={18}
              customColor="primary"
            />
            <div className="email-unsubscribe__success">
              {__t('email_unsubscribe.success')}
            </div>
          </div>
        </div>
        <div className="access-actions">
          <p className="email-unsubscribe__success_message">
            {__t('email_unsubscribe.success_message')}
          </p>
        </div>
        <p className="email-unsubscribe__success_message_additional">
          <span
            dangerouslySetInnerHTML={{
              __html: sanitizeGenericHtml(additionalMessage)
            }}
          />
        </p>
      </div>
    );
  }
}

export default EmailUnsubscribeSuccess;
